<template>
    <pre class="kb-line-diff" v-if="ops.length"><span
            v-for="(op, idx) in ops"
            :key="idx"
            class="kb-line-diff__line"
            :class="`kb-line-diff__line--${op.op}`"
        ><span class="kb-line-diff__sigil">{{ sigil(op.op) }}</span>{{ op.text }}<br/></span></pre>
</template>

<script>
import { lineDiff } from './kb-line-diff.js';

export default {
    name: 'kb-line-diff',

    props: {
        oldText: {type: String, default: ''},
        newText: {type: String, default: ''},
    },

    computed: {
        ops() {
            return lineDiff(this.oldText, this.newText);
        },
    },

    methods: {
        sigil(op) {
            if(op === 'add') return '+ ';
            if(op === 'del') return '- ';
            return '  ';
        },
    },
};
</script>

<style lang="scss" scoped>
.kb-line-diff {
    background: #fafafa;
    border: 1px solid #eee;
    border-radius: 3px;
    padding: 6px 8px;
    margin-top: 4px;
    font-family: 'SFMono-Regular', Menlo, Consolas, monospace;
    font-size: 0.78rem;
    line-height: 1.45;
    white-space: pre-wrap;
    word-break: break-word;
    overflow-x: auto;
}

.kb-line-diff__line {
    display: block;

    &--add {
        background: #e6ffed;
        color: #22863a;
    }

    &--del {
        background: #ffeef0;
        color: #b31d28;
    }

    &--eq {
        color: #666;
    }
}

.kb-line-diff__sigil {
    user-select: none;
    color: inherit;
    opacity: 0.65;
}
</style>



// WEBPACK FOOTER //
// src/views/pages/knowledge-base/kb-line-diff.vue